import { defineMeta } from '@/registry/types';

export const tablePageLayoutMeta = defineMeta({
  name: 'TablePageLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'List/table page with header (title, actions), toolbar (search/filters) and table content.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'ListPage',
  importPath: '@/templates/TablePageLayout',
  requiredProps: ['title', 'children'],
  optionalProps: ['description', 'actions', 'toolbar'],
  supportedStates: ['default'],
  designTokens: ['typography', 'spacing'],
  accessibility: ['Title is the page heading; place the table in the content region.'],
  usageExamples: ['<TablePageLayout title="Inventory" toolbar={<Search/>}><DataTable .../></TablePageLayout>'],
  antiPatterns: ['Do not embed unrelated dashboards here (use DashboardLayout content).'],
  llmSafe: true,
  whenToUse: ['Any list/table screen'],
  whenNotToUse: ['Dashboards (use DashboardLayout / DashboardExample)'],
});

export default tablePageLayoutMeta;
